import React, { useState, useEffect } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import { useSelector } from 'react-redux';
import methodModel from "../../methods/methods";
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from "../../components/global/layout";
import { Tooltip } from "antd";
import ImageUpload from "../../components/common/ImageUpload";
import { Editor } from "@tinymce/tinymce-react";
import tinymcModel from "../../models/tinymc.model";

const AddEdit = () => {
    const { id } = useParams()
    const [images, setImages] = useState({ image: '' });
    const [form, setform] = useState({ id: '', title: '', description: '', meta_description: "", meta_title: "", meta_key: "" })
    const history = useNavigate()
    const [submitted, setSubmitted] = useState(false)
    const user = useSelector((state) => state.user);
    const formValidation = [
        // { key: 'status', required: true }
    ]

    const handleSubmit = (e) => {
        e.preventDefault()
        setSubmitted(true)
        if (!form?.description  || !form?.meta_description) {
            return
        }
        let invalid = methodModel.getFormError(formValidation, form)
        if (invalid) return
        let method = 'post'
        let url = 'api/contentManagement'
        let value = {
            ...form,
            ...images
        }
        if (value.id) {
            method = 'put'
            url = 'content'
        } else {
            value.addedBy = user._id
            delete value.id
        }

        loader(true)
        ApiClient.allApi(url, value, method).then(res => {
            if (res.success) {
                history("/content")
            }
            loader(false)
        })
    }

    useEffect(() => {
        if (id) {
            loader(true)
            ApiClient.get('content', { id: id }).then(res => {
                if (res.success) {
                    let value = res.data
                    let payload = form

                    Object.keys(payload).map(itm => {
                        payload[itm] = value[itm]
                    })
                    payload.id = id
                    setform({
                        ...payload
                    })

                    let img = images
                    Object.keys(img).map(itm => {
                        img[itm] = value[itm]
                    })
                    setImages({ ...img })


                }
                loader(false)
            })
        }

    }, [id])

    const imageResult = (e, key) => {
        images[key] = e.value
        setImages(images)
    }

    return <>
        <Layout>
            <form onSubmit={handleSubmit}>
                <div className="pprofile1 shadow-lg">
                    <div className='flex items-center mb-8'>
                        <Tooltip placement="top" title="Back">

                            <Link to="/content" className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all  mr-3"><i className='fa fa-angle-left text-lg'></i></Link>
                        </Tooltip>
                        <div>
                            <h3 className="text-2xl font-semibold text-[#111827]">
                                {id ? 'Edit' : 'Add'}  Content Management
                            </h3>
                            <p class="text-sm font-normal text-[#525252]">Here you can see all about your content Management</p>
                        </div>
                    </div>

                    <h3 className="ViewUser mb-3"></h3>
                    <div className="form-row">
                        <div className="col-md-6 mb-3">
                            <label>Title<span className="star">*</span></label>
                            <input
                                type="text"
                                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                                value={form.title}
                                onChange={e => setform({ ...form, title: e.target.value })}
                                required
                            />
                        </div>

                        <div className="col-span-12 md:col-span-6">
                            <label className='lablefontcls'>Description<span className="star">*</span></label>
                            <Editor
                                textareaName="description"
                                value={form?.description}
                                className="tuncketcls"
                                onEditorChange={(newValue, editor) => {
                                    setform({ ...form, description: newValue });
                                }}
                                apiKey={tinymcModel.apiKey}
                                init={{
                                    selector: "textarea#autocompleter-cardmenuitem",
                                    height: 250,
                                    plugins: tinymcModel.plugins,
                                    toolbar: tinymcModel.toolbar,
                                }}
                                required
                            />
                            {submitted && !form?.description ? (
                                <div className="text-danger">Description is Required</div>
                            ) : (
                                <></>
                            )}
                        </div>
                        <div className="col-span-12 md:col-span-6">
                            <label className="lablefontcls">Image</label>
                            <br></br>
                            <ImageUpload
                                model="users"
                                result={(e) => imageResult(e, 'image')}
                                value={images.image || form.image}
                                multiple={false}
                            />
                            {/* {submitted && !images.image ? (
                                <div className="text-danger">Image is Required</div>
                            ) : (
                                <></>
                            )} */}
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>Meta Title<span className="star">*</span></label>
                            <input
                                type="text"
                                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                                value={form.meta_title}
                                onChange={e => setform({ ...form, meta_title: e.target.value })}
                                required
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label>Meta Keyword<span className="star">*</span></label>
                            <input
                                type="text"
                                className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                                value={form.meta_key}
                                onChange={e => setform({ ...form, meta_key: e.target.value })}
                                required
                            />
                        </div>

                        <div className="col-span-12 md:col-span-6">
                            <label className='lablefontcls'>Meta Description<span className="star">*</span></label>
                            <Editor
                                textareaName="description"
                                value={form?.meta_description}
                                className="tuncketcls"
                                onEditorChange={(newValue, editor) => {
                                    setform({ ...form, meta_description: newValue });
                                }}
                                apiKey={tinymcModel.apiKey}
                                init={{
                                    selector: "textarea#autocompleter-cardmenuitem",
                                    height: 250,
                                    plugins: tinymcModel.plugins,
                                    toolbar: tinymcModel.toolbar,
                                }}
                                required
                            />
                            {submitted && !form?.meta_description ? (
                                <div className="text-danger">Meta Description is Required</div>
                            ) : (
                                <></>
                            )}
                        </div>

                    </div>
                    <div className="text-right">
                        <button type="submit" className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2">Save</button>
                    </div>
                </div>


            </form>
        </Layout>
    </>
}

export default AddEdit